import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { CardInfo } from '../../pages/charge/models/card-info';

@Injectable({
  providedIn: 'root'
})
export class CardInfoDataService {
  private cardInfo$: BehaviorSubject<any>;

  constructor() {
    this.cardInfo$ = new BehaviorSubject(null);
  }

  setCardInfo(cardInfo: CardInfo): void {
    this.cardInfo$.next(cardInfo);
  }

  getCardInfo(): Observable<CardInfo> {
    return this.cardInfo$.asObservable();
  }

}
